import React, { useMemo } from 'react';
import { LOCAL_STORAGE_TOKEN, LOCAL_STORAGE_REFRESH_TOKEN } from 'constants/storage';
import { Navigate, useLocation } from 'react-router-dom';
import { LOGIN } from 'router/routes';
import Layout from 'components/Layout';
import { isTokenValid } from 'utils/getDecodedAccessToken';

interface IProps {
  noLayout: boolean;
}

const ProtectedRoute: React.FC<IProps> = ({ noLayout }) => {
  const location = useLocation();
  const token = useMemo(() => localStorage.getItem(LOCAL_STORAGE_TOKEN), []);

  if (!token || !isTokenValid(token)) {
    // Clear invalid token
    localStorage.removeItem(LOCAL_STORAGE_TOKEN);
    localStorage.removeItem(LOCAL_STORAGE_REFRESH_TOKEN);
    return <Navigate to={LOGIN} replace state={{ from: location }} />;
  }

  return <Layout noLayout={noLayout} />;
};

export default ProtectedRoute;
